"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Container = _interopRequireDefault(require("react-bootstrap/Container"));
var _Row = _interopRequireDefault(require("react-bootstrap/Row"));
var _indexModule = _interopRequireDefault(require("./index.module.css"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StyleWrapper = _styledComponents.default.div`

ul{

    background-color: #054894;
    box-shadow: 1px 1px 8px #c7c7c7;
    border-radius: 10px;
    padding: 20px 40px;
    color: #fff;

}

ul li{
    line-height: 30px;
}

p{
    // color:grey;
    margin-bottom:0.5rem;
}

h2{
    // color: #164686;
    margin-bottom:20px;
}

h4{
    // color: #164686;
}



`;
const TableWrapper = _styledComponents.default.div`

.table{
    border: 1px solid #ececec;
}
.table tr td:first-child {
    background: #25a7df;
    color: #fff;
  }

  td{
      vertical-align: middle;
      color:grey;
  }

@media(max-width:768px){
    .table-bordered thead td, .table-bordered thead th {
      min-width: auto !important;
      vertical-align: top !important;
      }
      .table-bordered > thead > tr > th:first-child{
        width: auto !important;
      }
      .table-responsive{
          overflow-x: auto;
      }
  }
`;
const Prequalification = _ref => {
  let {
    location
  } = _ref;
  (0, _react.useEffect)(() => {
    window.scrollTo(0, 0);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.hero_image
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", null, "Pre-Qualification & Pre-Approval"))), /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: _indexModule.default.pageContainer
  }, /*#__PURE__*/_react.default.createElement(StyleWrapper, null, /*#__PURE__*/_react.default.createElement("p", null, "Before shopping for your new home, it would be a good idea to get either pre-qualified or pre-approved. By taking one of these steps, you will be saving time in your home search by first helping us and yourself evaluate your overall financial situation. When you get either pre-qualified or pre-approved, you will get an idea on where you stand financially, and will gain a much more realistic expectation of the type of home that you will be able to afford. You also save time by not first finding a home, just to find out afterwards that you cannot get adequate financing when you do apply for a loan."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("p", null, "We can help you examine factors such as your debt vs. your income and assets and how it may affect your interest rate and loan amount. By getting either pre-qualified or pre-approved, we will have a better understanding of your needs and requirements, so we will be better prepared to provide proper consultation and get you on your way to getting approved for your loan. Sun West offers both a pre-qualification and a pre- approval for your convenience, and you can decide which option is better for you."), /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: _indexModule.default.headerRow
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.header_border
  }, " "), /*#__PURE__*/_react.default.createElement("h4", null, "Pre-Qualification Benefits:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "It\u2019s a simple and commitment free way to get an estimate on the interest rate, loan amount, and type of loan you are able to get. It does not constitute an obligation for either the borrower or the lender."), /*#__PURE__*/_react.default.createElement("li", null, "You can use this option to compare rates with as many lenders as you like."), /*#__PURE__*/_react.default.createElement("li", null, "You are not required to formally submit an application so there are no fees involved."), /*#__PURE__*/_react.default.createElement("li", null, "It shows the seller that you have an intention to buy and not just looking around."), /*#__PURE__*/_react.default.createElement("li", null, "Having a pre-qualification will give you more preference from the seller when you compete with buyers who don\u2019t have a pre-qualification letter."), /*#__PURE__*/_react.default.createElement("li", null, "A pre-qualification will help you search your home with a more targeted approach."))), /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: _indexModule.default.headerRow
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.header_border
  }, " "), /*#__PURE__*/_react.default.createElement("h4", null, "Pre-Approval Benefits:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "You can streamline the home buying and mortgage process by first getting pre-approved before you shop."), /*#__PURE__*/_react.default.createElement("li", null, "Once we have reviewed your credit and verified your financial situation with necessary supporting documentation submitted by you, we will issue you a conditional pre-approval letter. Note that you are not required to provide any documents prior to receiving a Loan Estimate. You may however voluntarily provide documentation and request a pre-approval."), /*#__PURE__*/_react.default.createElement("li", null, "A pre-approval gives you extra assurance that you will receive the financing for your home."), /*#__PURE__*/_react.default.createElement("li", null, "This option will help get most of your documentation and paperwork out of the way so you can save more time and reduce your stress before you buy."), /*#__PURE__*/_react.default.createElement("li", null, "Some sellers may prefer a pre-approval, and a pre-approval makes you a serious buyer with even more increased preference from the seller."), /*#__PURE__*/_react.default.createElement("li", null, "A pre-approval will give you more negotiating power when you are competing with other buyers.")), /*#__PURE__*/_react.default.createElement("p", null, " Start your Pre-Qualification or Pre-Approval by clicking ", /*#__PURE__*/_react.default.createElement("a", {
    href: "https://seemyloanstatus.com/ApplyNow/?lof=LMT0&extLeadSource=SUNWESTMORTGAGE",
    target: "_blank"
  }, "here"))))));
};
var _default = exports.default = Prequalification;